import React from "react";
import ReactDOM from "react-dom";
import styled, { css } from "styled-components/macro";
import Card from "./Card";
import { DPIconClose } from "../assets/icons";
import media from "../constants/MediaQuery";

type modalType = {
  showModal: boolean;
  onBackdropClick?: () => void;
  onCloseClick?: () => void;
  maxModal?: boolean | number | Array<number | string>;
  height?: string;
  width?: string;
  noBackground?: boolean;
  noPadding?: boolean;
  contentStyle?: object;
  top?: boolean;
};

const Portal: React.FC = ({ children }) =>
  ReactDOM.createPortal(
    children,
    document.getElementById("root-modal") as Element
  );

export const Modal: React.FC<modalType> = ({
  showModal,
  maxModal,
  height,
  width,
  onCloseClick,
  onBackdropClick,
  noBackground,
  children,
  noPadding,
  contentStyle,
  top,
}) => {
  const baseCss = "Modal__ModalStyling--content";
  return (
    <Portal>
      {showModal && (
        <ModalStyling
          maxModal={maxModal}
          noBackground={noBackground}
          noPadding={noPadding}
          height={height}
          width={width}
        >
          <div
            role="presentation"
            className="Modal__ModalStyling--backdrop"
            onClick={onBackdropClick}
          />
          <Card
            className={`${baseCss} ${top ? `${baseCss}-card--to-top` : ""}`}
          >
            {onCloseClick && (
              <span className={`${baseCss}-close-modal`}>
                <button type="button" onClick={onCloseClick}>
                  <DPIconClose />
                </button>
              </span>
            )}
            <div className={`${baseCss}-card`} style={contentStyle}>
              {children}
            </div>
          </Card>
        </ModalStyling>
      )}
    </Portal>
  );
};

const ModalStyling = styled.div<{
  maxModal?: boolean | number | Array<number | string>;
  noBackground?: boolean;
  noPadding?: boolean;
  height?: string;
  width?: string;
}>`
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .Modal__ModalStyling--content {
    flex-direction: column;
    padding: 0;
  }

  .Modal__ModalStyling--backdrop {
    transition: all 1.5s;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    background: #00000037;
  }
  .Modal__ModalStyling--content {
    position: relative;
    max-width: 95%;
    max-height: 100%;

    &-card {
      overflow: auto;
      width: 100%;
      padding: ${({ noPadding }) => (noPadding ? "0" : "20px 20px 20px 20px")};

      ::-webkit-scrollbar {
        width: 3px;
        height: 3px;
      }
      /* ${media.tablet`
            padding: 0px;
        `} */
      &--to-top {
        position: absolute;
        top: 50px !important;
        height: min-content;
      }
    }

    &-close-modal {
      position: absolute;
      /* display: flex; */
      /* justify-content: flex-end;
      margin-bottom: 10px;
      padding: 20px 20px 0 20px; */
      right: 10px;
      top: 10px;
      z-index: 3000;

      > button {
        cursor: pointer;
        background: none;
        border: none;
      }
    }

    ${({ maxModal, height, width }) =>
      maxModal &&
      css`
        height: ${height ?? "90%"};
        width: ${width ?? "90%"};
        max-width: ${typeof maxModal === "number"
          ? `${maxModal}px`
          : typeof maxModal === "object" &&
            (+maxModal[0] ? `${maxModal[0]}px` : maxModal[0])};
        max-height: ${typeof maxModal === "object" &&
        (+maxModal[1] ? `${maxModal[1]}px` : maxModal[1])};

        ${media.query1050`
          height: calc(100% - 50px);
        `}
        ${media.tablet`
            width: 90%;
        `}
        ${media.mobile`
            width: 95%;
        `}
      `}

    ${({ noBackground }) =>
      noBackground &&
      css`
        background: unset;
        box-shadow: unset;
      `};

    ${media.query1050`
      top: -25px;
    `}
  }
`;

export default Modal;
